import script from "./AdminOrderListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrderListView.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrderListView.vue?vue&type=style&index=0&id=289beabf&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-289beabf"]])

export default __exports__